import _ from 'lodash';
import WdUtils from '@main/utils';

function MessagesModel(data) {
  data = data || {};

  return _.defaults(data, {
    id: WdUtils.generateGUID(),
    icon: 'heroicons-solid:star',
    // -------------
    title: 'Notificacion',
    description: undefined,
    priority: 'normal',
    status: '',
    image: undefined,
    uri: undefined,
    isClicked: undefined,
    payload: undefined,
    created_at: new Date().toISOString(),
    // -----------------
    variant: 'default',
  });
}

export default MessagesModel;
